import Launch from '@/domain/launch/index';
import { getAll } from '@/infra/launch/launchRepository';

export async function launchGetAll(): Promise<{
  items: ResolvedData;
  scrollId: string;
}> {
  try {
    const res = await getAll();
    const data: ResolvedData = res.items.map((chunk) => new Launch(chunk));
    return { items: data, scrollId: res.scrollId };
  } catch (error: any) {
    if (error.message === 'ServerError') {
      throw error;
    }
    throw error;
  }
}

export default launchGetAll;

export type ResolvedData = Launch[];
